/* eslint-disable react/no-array-index-key */
import React from 'react'

import { Image, SectionHeaderComponent } from '../../components'
import useElementOnScreen from '../../hooks/useElementOnScreen'
import {
  activeImage,
  bacgroundImage,
  contentContainer,
  imageArr,
  sectionContainer,
} from './SectionLayout.module.css'

const SectionLayout = ({
  activate,
  backGround,
  backGroundArr,
  backgroundClassName,
  children,
  component,
  containerwidth,
  content,
  contentBackground,
  cta,
  ctaColumn,
  ctaExtraClassName,
  extraBtnClassName,
  extraClassName,
  extraContentClassName,
  extraContentFontClassName,
  extraDescriptionClassName,
  extraHeaderClassName,
  extraHeadingClassName,
  extraHeadingContainerClassName,
  extraKickerClassName,
  heading,
  heroHeader,
  id,
  iscarorusel,
  isVideo,
  kicker,
  renderedContent,
  withCta,
  withHeader,
  withParagraph,
}) => {
  const [setRef, visible] = useElementOnScreen()
  return (
    <section
      ref={setRef}
      className={`${sectionContainer} ${extraClassName}`}
      id={id}
    >
      <div className={`${contentContainer} ${extraContentClassName}`}>
        {withHeader && (
          <SectionHeaderComponent
            component={component}
            containerwidth={containerwidth}
            content={content}
            cta={cta}
            ctaColumn={ctaColumn}
            ctaExtraClassName={ctaExtraClassName}
            extraBtnClassName={extraBtnClassName}
            extraClassName={extraHeaderClassName}
            extraContentClassName={extraContentFontClassName}
            extraDescriptionClassName={extraDescriptionClassName}
            extraHeadingClassName={extraHeadingClassName}
            extraHeadingContainerClassName={extraHeadingContainerClassName}
            extraKickerClassName={extraKickerClassName}
            heading={heading}
            heroHeader={heroHeader}
            iscarorusel={iscarorusel}
            kicker={kicker}
            renderedContent={renderedContent}
            withCta={withCta}
            withParagraph={withParagraph}
          />
        )}
        {children}
        {contentBackground && visible && (
          <Image
            alt={contentBackground.altText || 'Kliniken Image'}
            className={`${bacgroundImage} ${backgroundClassName}`}
            loading="eager"
            quality={100}
            src={contentBackground.node.localFile.childImageSharp}
          />
        )}
      </div>
      {backGround && visible && !iscarorusel && !isVideo && (
        <Image
          alt={backGround.altText || 'Kliniken Image'}
          className={`${bacgroundImage} ${backgroundClassName}`}
          loading="eager"
          quality={100}
          src={backGround.node.localFile.childImageSharp}
        />
      )}
      {!isVideo &&
        backGroundArr &&
        visible &&
        !backGround &&
        !iscarorusel &&
        backGroundArr.map((item, index) => {
          return (
            <Image
              key={index}
              alt={item.altText || 'Kliniken Image'}
              className={`${bacgroundImage} ${backgroundClassName} ${imageArr} ${
                index === activate ? activeImage : ''
              }`}
              loading="eager"
              quality={100}
              src={item.node.localFile.childImageSharp}
            />
          )
        })}
    </section>
  )
}

export default SectionLayout
